import {EvaluationSubCriteriaImportanceScore} from '@frontend/shared-api';

export const IMPORTANCE_SCORE_LABEL_KEYS: Record<EvaluationSubCriteriaImportanceScore, string> = {
  [EvaluationSubCriteriaImportanceScore.BASIC_ATTRIBUTE]:
    'evaluation.importanceScores.basicAttribute',
  [EvaluationSubCriteriaImportanceScore.PERFORMANCE_ATTRIBUTE]:
    'evaluation.importanceScores.performanceAttribute',
  [EvaluationSubCriteriaImportanceScore.ENTHUSIASM_ATTRIBUTE]:
    'evaluation.importanceScores.enthusiasmAttribute',
  [EvaluationSubCriteriaImportanceScore.INDIFFERENT_ATTRIBUTE]:
    'evaluation.importanceScores.indifferentAttribute',
  [EvaluationSubCriteriaImportanceScore.NOT_RELEVANT]: 'evaluation.importanceScores.notRelevant',
};
